import React from "react";
import { Menu } from "semantic-ui-react";

const ReminderFor = (props) => {
  return (
    <div className="list">
      <Menu className="cu-tab" pointing secondary>
        <Menu.Item
          name="Athletes"
          active={!props.current}
          onClick={() => {
            props.on(false);
          }}
        />
        <Menu.Item
          name="Advocates"
          active={props.current}
          onClick={() => props.on(true)}
        />
      </Menu>
    </div>
  );
};

export default ReminderFor;
